import { baseAxios } from "config";

/**
 * Updates a dynamic form with new form data and metadata
 * @param {string} formId - The ID of the form to update
 * @param {object} formData - The updated form data
 * @param {object} metadata - The form metadata (audience, visibility, onboarding)
 * @returns {Promise} - The API response
 */
const updateDynamicForm = async ({ formId, formData, metadata, formName }) => {
  try {
    const body = {};
    if (formData) {
      body.formData = formData;
    }
    if(formName)
      body.formName = formName;
    if (metadata) {
      body.metadata = metadata;
    }
    const response = await baseAxios.put(`/llm/dynamicForms/${formId}`, body);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export default updateDynamicForm;
